/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponseData =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/**
 * Standard error response object
 */
export class PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$:
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponseData;

  constructor(
    err:
      PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name =
      "PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse";
  }
}

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$inboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse(
        v,
      );
    });

/** @internal */
export type PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$outboundSchema:
  z.ZodType<
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$Outbound,
    z.ZodTypeDef,
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse
  > = z.instanceof(
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$ {
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$inboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$outboundSchema;
  /** @deprecated use `PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$Outbound` instead. */
  export type Outbound =
    PostApiLeadScraperMicroserviceApiV1OrganizationsTenantsApiKeysErrorResponse$Outbound;
}
